/**
 * Bater ponto — o contrato com o painel admin do Green Village.
 *
 * O ponto é do painel: vive na tabela que a tela de Bater Ponto de lá lê e
 * escreve. O GreenVoice só tem um relógio de pé que abre essa mesma tela, e
 * cada batida vai para lá. Por isso os nomes e a regra são os DO PAINEL.
 */
/**
 * Os quatro tipos, com os nomes EXACTOS que o painel grava — com acento e
 * maiúscula. Um `"Saida"` sem acento seria um tipo novo que as contas de lá
 * não somam. A ordem é a do dia de trabalho.
 */
export const PONTO_TIPOS = ["Entrada", "Início almoço", "Retorno almoço", "Saída"];
export function ehPontoTipo(valor) {
    return typeof valor === "string" && PONTO_TIPOS.includes(valor);
}
/**
 * Que batida é permitida a seguir à última do dia. É a MESMA regra do
 * `isPunchAllowed` da tela do painel: se divergissem, o relógio deixava gravar
 * uma sequência que o painel depois soma mal.
 */
export function podeBaterPonto(ultimo, tipo) {
    if (!ultimo)
        return tipo === "Entrada";
    if (ultimo === "Entrada")
        return tipo === "Início almoço" || tipo === "Saída";
    if (ultimo === "Início almoço")
        return tipo === "Retorno almoço";
    if (ultimo === "Retorno almoço")
        return tipo === "Saída";
    if (ultimo === "Saída")
        return tipo === "Entrada";
    return false;
}
/**
 * O tipo da batida mais recente de uma lista, ou `null` sem batidas. `data_hora`
 * tem sempre o mesmo formato, por isso ordena-se como texto; duas no MESMO
 * segundo (um duplo clique) desempatam pelo id — o maior foi gravado depois.
 */
export function ultimoTipo(registros) {
    let ultimo = null;
    for (const r of registros) {
        if (!ultimo || r.data_hora > ultimo.data_hora || (r.data_hora === ultimo.data_hora && r.id > ultimo.id)) {
            ultimo = r;
        }
    }
    return ultimo ? ultimo.tipo : null;
}
//# sourceMappingURL=ponto.js.map